import { action, observable, toJS } from "mobx";

const STORE_CONFIG = "config";

class ConfigStore {
  constructor(rawState = {}) {
    if (rawState.machines) {
      this.setMachines(rawState.machines);
    }
    if (rawState.cleaningRates) {
      this.setCleaningRates(rawState.cleaningRates);
    }
    if (rawState.suppliers) {
      this.setSuppliers(rawState.suppliers);
    }
    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.locations) {
      this.setLocations(rawState.locations);
    }
    if (rawState.locationsById) {
      this.setLocationsById(rawState.locationsById);
    }
    if (rawState.bins) {
      this.setBins(rawState.bins);
    }
    if (rawState.users) {
      this.setUsers(rawState.users);
    }
    if (rawState.workshifts) {
      this.setWorkShifts(rawState.workshifts);
    }
    if (rawState.palletstatuses) {
      this.setPalletStatuses(rawState.palletstatuses);
    }
    if (rawState.weighbillTresholds) {
      this.setWeighbillTresholds(rawState.weighbillTresholds);
    }
    if (rawState.weighbillMultipliers) {
      this.setWeighbillMultipliers(rawState.weighbillMultipliers);
    }
  }
  toJS() {
    return {
      machines: toJS(this.machines),
      cleaningRates: toJS(this.cleaningRates),
      items: toJS(this.items),
      itemsStructure: toJS(this.itemsStructure),
      suppliers: toJS(this.suppliers),
      locations: toJS(this.locations),
      locationsById: toJS(this.locationsById),
      bins: toJS(this.bins),
      users: toJS(this.users),
      workshifts: toJS(this.workshifts),
      palletstatuses: toJS(this.palletstatuses),
      weighbillTresholds: toJD(this.weighbillTresholds),
      weighbillMultipliers: toJD(this.weighbillMultipliers),
    };
  }

  @action setData(data) {
    const { TaskData: taskData, Warehouse: warehouse } = data;
    this.setMachines(taskData.Machines);
    this.setItemsStructure(taskData.ItemsStructure);
    this.setItems(taskData.Items);
    this.setSuppliers(taskData.Suppliers);
    this.setCleaningRates(taskData.CleaningRates);
    this.setLocations(
      Object.entries(warehouse.Locations).map(([id, obj]) => ({
        id,
        name: obj.Name,
      }))
    );
    this.setLocationsById(warehouse.Locations);
    this.setBins(
      Object.entries(warehouse.Bins).map(([id, obj]) => ({
        id,
        name: obj.Name,
        locationId: obj.LocationId,
        levelnum: obj.Levelnum || 1,
      }))
    );
    this.setUsers(taskData.Users);
    this.setWorkShifts(taskData.WorkShifts);
    this.setPalletStatuses(taskData.PalletStatuses);
    this.bagtypes = [
      { value: 1, label: "BB" },
      { value: 2, label: "ZS" },
    ];
    this.setWeighbillTresholds(taskData.WeighBillTresholds);
    this.setWeighbillMultipliers(taskData.WeighBillMultipliers);
  }

  @observable machines;
  @observable cleaningRates;
  @observable items;
  @observable itemsStructure;
  @observable suppliers;
  @observable locations;
  @observable locationsById;
  @observable bins;
  @observable users;
  @observable workshifts;
  @observable palletstatuses;
  @observable weighbillTresholds;
  @observable weighbillMultipliers;

  @action setMachines(value) {
    this.machines = value;
  }
  @action setCleaningRates(value) {
    this.cleaningRates = value;
  }
  @action setItems(value) {
    this.items = value;
  }
  @action setItemsStructure(value) {
    this.itemsStructure = value;
  }
  @action setSuppliers(value) {
    this.suppliers = value;
  }
  @action setLocations(value) {
    this.locations = value;
  }
  @action setLocationsById(value) {
    this.locationsById = value;
  }
  @action setBins(value) {
    this.bins = value;
  }
  @action setUsers(value) {
    this.users = value;
  }
  @action setWorkShifts(value) {
    this.workshifts = value;
  }
  @action setPalletStatuses(value) {
    this.palletstatuses = value;
  }
  @action setWeighbillTresholds(value) {
    this.weighbillTresholds = value;
  }
  @action setWeighbillMultipliers(value) {
    this.weighbillMultipliers = value;
  }
}

export { ConfigStore, STORE_CONFIG };
